export default "__VITE_ASSET__BVcGs9$4__"